(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorafly-lp-support-v4"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sorafly-lp-support')) {
  customElements.define('sorafly-lp-support', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.bar = this.querySelector('.sf4-support-bar');
      if (!this.bar) return;
      this.update = () => {
        if (this.pending) return;
        this.pending = requestAnimationFrame(() => {
          this.pending = null;
          if (!this.isConnected) return;
          const hero = document.querySelector('.sf4-lp .sf4-hero');
          const anchor = document.getElementById('sf4-purchase');
          const purchase = anchor?.closest('.shopify-section')?.nextElementSibling;
          const choices = document.querySelector('.sf4-lp--brand .sf4-products');
          const footer = document.querySelector('.page-wrapper > footer');
          const header = document.querySelector('header-component');
          const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
          const height = window.innerHeight;
          const visible = element => {
            if (!element) return false;
            const r = element.getBoundingClientRect();
            return r.top < height - 100 && r.bottom > headerBottom + 80;
          };
          const pastHero = hero && hero.getBoundingClientRect().bottom < headerBottom + 20;
          const reachedFooter = footer && footer.getBoundingClientRect().top < height - 90;
          const inPurchase = this.dataset.page === 'product' ? visible(purchase) : visible(choices);
          this.bar.hidden = !pastHero || !!reachedFooter || inPurchase;
        });
      };
      window.addEventListener('scroll', this.update, { passive: true, signal: this.abort.signal });
      window.addEventListener('resize', this.update, { passive: true, signal: this.abort.signal });
      window.addEventListener('load', this.update, { once: true, signal: this.abort.signal });
      document.addEventListener('shopify:section:load', this.update, { signal: this.abort.signal });
      this.update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      if (this.pending) cancelAnimationFrame(this.pending);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sorasato-kitchen-v3"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sorasato-kitchen-browser')) {
  class SorasatoKitchenBrowser extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      if (!this.querySelector('[data-grid]')) { requestAnimationFrame(() => this.connectedCallback()); return; }
      this.ready=true; this.abort=new AbortController(); this.grid=this.querySelector('[data-grid]');
      this.records=new Map(); this.products=new Map(); this.limit=12; this.visited=new Set(); this.next=this.dataset.next;
      this.extra=Array.from(this.querySelector('[data-extra-products]').content.querySelectorAll('[data-extra]')).map(e=>({...e.dataset,recipes:this.array(e.dataset.recipes)}));
      this.readRecords(this); this.buildOptions(); this.readState();
      const signal=this.abort.signal;
      this.querySelector('[data-search-form]').addEventListener('submit',e=>{e.preventDefault();this.limit=12;this.update(true);this.scrollResults();},{signal});
      for(const name of ['category','time','product']) this.querySelector('[data-'+name+']').addEventListener('change',()=>{this.limit=12;this.source='';this.update(true);},{signal});
      this.querySelectorAll('[data-reset]').forEach(b=>b.addEventListener('click',()=>this.reset(),{signal}));
      this.querySelector('[data-more]').addEventListener('click',()=>{this.limit+=12;this.update(false);},{signal});
      this.querySelector('[data-retry]').addEventListener('click',()=>{this.querySelector('[data-error]').hidden=true;this.loadRemaining();},{signal});
      window.addEventListener('popstate',()=>{this.readState();this.limit=12;this.update(false);},{signal});
      this.querySelector('[data-filters]').hidden=false;this.update(false);
      if(Number(this.dataset.page)>1){const first=new URL(location.href);first.searchParams.set(this.dataset.pageParam||'page','1');this.next=first.href;}
      this.loadRemaining();
    }
    disconnectedCallback(){this.abort?.abort();this.ready=false;}
    array(s){try{const v=JSON.parse(s||'[]');return Array.isArray(v)?v:[];}catch{return [];}}
    norm(s){return String(s||'').normalize('NFKC').toLocaleLowerCase('ja-JP').replace(/\s+/g,' ').trim();}
    minutes(value){
      const s=this.norm(value);
      if(/[\u9664\u7f6e\u6f2c+]/u.test(s))return null;
      const m=s.match(/^(?:\u7d04)?\s*(?:(\d+(?:\.\d+)?)\s*\u6642\u9593)?\s*(\d+)?\s*(?:[\u301c\uff5e~-]\s*(\d+))?\s*\u5206?$/u);
      return m&&(m[1]||m[2])?Number(m[1]||0)*60+Number(m[3]||m[2]||0):null;
    }
    readRecords(parent){
      for(const element of parent.querySelectorAll('[data-record]')){
        const id=element.dataset.handle;if(!id||this.records.has(id))continue;
        const categories=this.array(element.dataset.categories),occasions=this.array(element.dataset.occasions);
        if(occasions.includes('\u304a\u3064\u307e\u307f')&&!categories.includes('\u304a\u3064\u307e\u307f'))categories.push('\u304a\u3064\u307e\u307f');
        if(categories.some(c=>['\u9eba','\u3054\u306f\u3093'].includes(c))&&!categories.includes('\u9eba\u30fb\u3054\u306f\u3093'))categories.push('\u9eba\u30fb\u3054\u306f\u3093');
        const linked=this.array(element.dataset.products).filter(p=>p.handle&&p.title&&p.url);
        for(const p of this.extra)if(p.recipes.includes(id)&&!linked.some(x=>x.handle===p.handle))linked.push(p);
        this.records.set(id,{element,id,categories,linked,minutes:this.minutes(element.dataset.duration),priority:Number(element.dataset.priority)||0,text:this.norm(element.dataset.search+' '+linked.map(p=>p.title).join(' '))});
        if(element.parentNode!==this.grid)this.grid.append(element);
        for(const p of linked){if(!this.products.has(p.handle))this.products.set(p.handle,{...p,recipes:new Set()});this.products.get(p.handle).recipes.add(id);}
      }
    }
    ensure(select,value){if(value&&!Array.from(select.options).some(o=>o.value===value))select.add(new Option(value,value));select.value=value;}
    buildOptions(){
      const category=this.querySelector('[data-category]'),product=this.querySelector('[data-product]'),oldCategory=category.value,oldProduct=product.value;
      const categories=[...new Set([...this.records.values()].flatMap(r=>r.categories))].sort((a,b)=>a.localeCompare(b,'ja'));
      category.replaceChildren(new Option(this.dataset.allLabel,''));for(const c of categories)category.add(new Option(c,c));this.ensure(category,oldCategory);
      const products=[...this.products.values()].sort((a,b)=>b.recipes.size-a.recipes.size||a.title.localeCompare(b.title,'ja'));
      product.replaceChildren(new Option(this.dataset.allLabel,''));for(const p of products)product.add(new Option(p.title,p.handle));this.ensure(product,oldProduct);
      const quick=this.querySelector('[data-quick]');quick.replaceChildren();
      for(const c of ['\u8089\u6599\u7406','\u9b5a\u6599\u7406','\u91ce\u83dc\u6599\u7406','\u9eba\u30fb\u3054\u306f\u3093','\u304a\u3064\u307e\u307f'].filter(c=>categories.includes(c))){
        const b=document.createElement('button');b.type='button';b.textContent=c;b.dataset.quickCategory=c;b.setAttribute('aria-pressed','false');b.addEventListener('click',()=>{this.clearInputs();category.value=c;this.limit=12;this.update(true);this.scrollResults();},{signal:this.abort.signal});quick.append(b);
      }
      quick.hidden=!quick.children.length;
      const grid=this.querySelector('[data-product-grid]');grid.replaceChildren();
      for(const p of products){
        const card=document.createElement('article');card.className='skv3__product';
        if(p.image){const i=document.createElement('img');i.src=p.image;i.alt=p.title;i.width=300;i.height=300;i.loading='lazy';card.append(i);}
        const h=document.createElement('h3');h.textContent=p.title;card.append(h);
        const count=document.createElement('p');count.textContent=this.count(p.recipes.size);card.append(count);
        const b=document.createElement('button');b.type='button';b.textContent=this.dataset.recipeLabel+' \u2192';b.dataset.filterProduct=p.handle;b.addEventListener('click',()=>{this.clearInputs();product.value=p.handle;this.limit=12;this.update(true);this.scrollResults();},{signal:this.abort.signal});card.append(b);
        const a=document.createElement('a');a.href=p.url;a.textContent=this.dataset.shopLabel;card.append(a);grid.append(card);
      }
      this.querySelector('[data-products-section]').hidden=!products.length;this.querySelector('[data-product-jump]').hidden=!products.length;
    }
    readState(){
      const p=new URL(location.href).searchParams;
      this.querySelector('[data-search-input]').value=p.get('q')||'';
      this.ensure(this.querySelector('[data-category]'),p.get('category')||'');
      let product=p.get('product')||p.get('ingredient')||'';
      if(!product&&p.get('seasoning')){
        const legacy=p.get('seasoning');
        const labels={'yakiniku-sauce':'\u713c\u8089','shio-dare':'\u5869\u3060\u308c','sudachi-ponzu':'\u3059\u3060\u3061','awaji-onion-dressing':'\u30c9\u30ec\u30c3\u30b7\u30f3\u30b0','nikushio-premium':'Premium','garlic-yuzu-kosho':'\u3086\u305a\u3053\u3057\u3087\u3046','garisco':'\u30ac\u30ea\u30b9\u30b3','nikushio-red':'RED'};
        product=[...this.products.values()].find(x=>x.handle===legacy||x.handle.includes(legacy)||this.norm(x.title).includes(this.norm(labels[legacy]||legacy)))?.handle||'unmatched:'+legacy;
      }
      this.ensure(this.querySelector('[data-product]'),product);
      const legacyTime=p.get('category')==='5\u5206\u30fb15\u5206';
      this.querySelector('[data-time]').value=p.get('max_time')||(legacyTime?'15':'');
      if(legacyTime)this.querySelector('[data-category]').value='';
      this.source=p.get('source')==='marche'?'marche':'';
    }
    update(writeUrl){
      const q=this.querySelector('[data-search-input]').value.trim(),category=this.querySelector('[data-category]').value,product=this.querySelector('[data-product]').value,time=this.querySelector('[data-time]').value;
      const words=this.norm(q).split(' ').filter(Boolean),direct=new Set(this.extra.flatMap(p=>p.recipes));
      const matches=[...this.records.values()].filter(r=>(!category||r.categories.includes(category))&&(!product||r.linked.some(p=>p.handle===product))&&(!time||(r.minutes!==null&&r.minutes<=Number(time)))&&(!this.source||direct.has(r.id))&&words.every(w=>r.text.includes(w))).sort((a,b)=>b.priority-a.priority||a.id.localeCompare(b.id));
      this.records.forEach(r=>{r.element.hidden=true;});matches.slice(0,this.limit).forEach(r=>{this.grid.append(r.element);r.element.hidden=false;});
      this.querySelector('[data-status]').textContent=this.count(matches.length);this.querySelector('[data-empty]').hidden=matches.length>0||this.busy;this.querySelector('[data-more]').hidden=matches.length<=this.limit;
      this.querySelectorAll('[data-quick-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.quickCategory===category)));
      if(writeUrl){const url=new URL(location.href);for(const key of ['q','category','product','max_time','seasoning','ingredient','source',this.dataset.pageParam||'page'])url.searchParams.delete(key);for(const [k,v]of Object.entries({q,category,product,max_time:time,source:this.source}))if(v)url.searchParams.set(k,v);history.pushState({},'',url);}
    }
    count(n){return this.dataset.countLabel.replace('{count}',String(n));}
    clearInputs(){for(const s of ['[data-search-input]','[data-category]','[data-product]','[data-time]'])this.querySelector(s).value='';this.source='';}
    reset(){this.clearInputs();this.limit=12;this.update(true);}
    scrollResults(){this.querySelector('.skv3__head h2').focus({preventScroll:true});this.querySelector('.skv3__recipes').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}
    async loadRemaining(){
      if(this.busy)return;this.busy=true;this.querySelector('[data-loading]').hidden=!this.next;
      try{
        while(this.next){
          const url=new URL(this.next,location.href),current=new URL(location.href);url.searchParams.set('section_id',this.dataset.section);
          for(const key of ['view','preview_theme_id'])if(current.searchParams.has(key))url.searchParams.set(key,current.searchParams.get(key));
          if(url.origin!==location.origin||this.visited.has(url.href))throw Error('Invalid pagination');
          const response=await fetch(url,{credentials:'same-origin',signal:AbortSignal.any([this.abort.signal,AbortSignal.timeout(15000)])});if(!response.ok)throw Error('HTTP '+response.status);
          const nextDocument=new DOMParser().parseFromString(await response.text(),'text/html'),root=nextDocument.querySelector('sorasato-kitchen-browser');if(!root)throw Error('Missing section');
          this.visited.add(url.href);this.readRecords(root);this.next=root.dataset.next;
        }
        this.buildOptions();this.readState();this.querySelector('[data-pagination]').hidden=true;
      }catch(e){if(e.name!=='AbortError')this.querySelector('[data-error]').hidden=false;}
      finally{this.busy=false;this.querySelector('[data-loading]').hidden=true;this.update(false);}
    }
  }
  customElements.define('sorasato-kitchen-browser',SorasatoKitchenBrowser);
}

  } catch(e) { console.error(e); }
})();
})();
